import React, { PureComponent } from 'react';
import { toast } from 'react-toastify';
import _ from 'lodash';
import IconToast from '../../../components/NewToast';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, TextField, Typography } from '@mui/material';
import LockResetRoundedIcon from '@mui/icons-material/LockReset';
import { withStyles } from 'tss-react/mui';
import { formatEmail } from '../../../utils/email';
import LoadingBackdrop from '../../../components/LoadingBackdrop/LoadingBackdrop';
import ForgotPasswordStyles from '../ForgotPasswordStyles';

class ForgotPasswordView extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      email: '',
      err: {},
      disabled: false,
      open: false
    };
    this.handleChange = this.handleChange.bind(this);
    this.submitForgotPasswordForm = this.submitForgotPasswordForm.bind(this);
  }

  handleChange(event) {
    if (event.target.name === 'email') {
      delete this.state.err.email;
    }
    this.setState({ [event.target.name]: event.target.value });
  }

  componentDidMount() {
    /*to display the page language as per the browser language*/
    var user = this.props.userDetails;
    if (_.isEmpty(user)) {
      var userLang = navigator.language || navigator.userLanguage;
      const language = userLang === 'zh-HK' ? 'zh-Hant-HK' : userLang === 'zh-CN' ? 'zh' : 'en';
      this.props.selectedLocale(language);
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { intl } = this.props;
    if (nextProps.forgotPasswordPhase === true) {
      this.setState({
        email: '',
        open: true,
        disabled: true
      });
      //   toast.info(
      //     intl.formatMessage({
      //       id: 'Reset link has been sent to your email address.'
      //     })
      //   );
    } else if (nextProps.forgotPasswordPhase === false) {
      toast.info(
        IconToast('info', intl.formatMessage({ id: nextProps.message }, nextProps.forgotPasswordMessageExtras)),
        { className: 'new-toast' }
      );
      this.setState({ disabled: false });
    }
    // if (nextProps.forgotPasswordPhase === 'loading') {
    //   toast.info(intl.formatMessage({ id: 'Sending request...' }));
    // }
  }

  //sending customer's email to backend in case customer forget password he will get a reset link through email to set a new password.
  submitForgotPasswordForm(event) {
    event.preventDefault();
    const { disabled } = this.state;
    if (!disabled) {
      const err = {};
      const formattedEmail = formatEmail(this.state.email);
      if (formattedEmail === '') {
        err.email = 'Email is required';
      } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(formattedEmail)) {
        err.email = 'Invalid email';
      }
      this.setState({ err });
      if (!Object.keys(err).length) {
        const data = {};
        data.email = formattedEmail;
        this.props.forgotPassword(data);
      }
    }
  }

  render() {
    const { intl, classes } = this.props;
    const { disabled, open, err } = this.state;
    return (
      <div className={classes.forgotWrapper}>
        {this.props.forgotPasswordPhase === 'loading' && <LoadingBackdrop open={true} />}
        <form className={classes.form} onSubmit={this.submitForgotPasswordForm} noValidate>
          <div className={classes.forgotIcon}>
            <LockResetRoundedIcon style={{ fontSize: 34 }} />
          </div>
          <Typography className={classes.forgotHint}>
            {intl.formatMessage({ id: 'forgot-password-hint' })}
          </Typography>

          <TextField
            variant="outlined"
            margin="normal"
            fullWidth
            name="email"
            value={this.state.email}
            onChange={this.handleChange}
            disabled={disabled}
            className={classes.logindetails}
            label={intl.formatMessage({ id: 'Login Email' })}
            error={!!err.email}
            helperText={err.email ? intl.formatMessage({ id: err.email }) : ''}
            slotProps={{
              input: {
                classes: {
                  root: classes.inputBase,
                  input: classes.input
                }
              },
              inputLabel: { className: classes.inputLabel }
            }}
          />

          <div className={classes.forgotButtonWrap}>
            <Button
              type="submit"
              variant="contained"
              color="primary"
              fullWidth
              className={classes.submit}
              onClick={this.submitForgotPasswordForm}
              disabled={disabled}
            >
              {intl.formatMessage({ id: 'Get Password' })}
            </Button>
          </div>
        </form>

        <Dialog
          open={open}
          onClose={() => {
            this.setState({ open: false });
          }}
          slotProps={{ paper: { sx: { borderRadius: '16px', padding: '8px 4px' } } }}
        >
          <DialogContent>
            <DialogContentText sx={{ textAlign: 'center' }}>
              {intl.formatMessage({ id: 'Reset link has been sent to your email address.' })}
            </DialogContentText>
          </DialogContent>
          <DialogActions sx={{ justifyContent: 'center' }}>
            <Button
              color="primary"
              onClick={() => {
                this.setState({ open: false });
              }}
            >
              {intl.formatMessage({ id: 'OK' })}
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

export default withStyles(ForgotPasswordView, ForgotPasswordStyles);
